<template lang="html">

    <div class="mng-vr-scene2">
      <VrScene ref="vrScene"
               class="mng-vr-scene__stage"
               :scene-id="$route.params.modelId"
               @initialized="onInitialized"
               @right-click="onPlaceLabel"
               @label-clicked="onClickLabel"
               @on_shoted='onShoted' />
    </div>

</template>

<script>
import VrScene from '../../../components/ai-vr-scene.vue';
export default {
  components: {
    VrScene
  },
  filters: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  }

};
</script>

<style lang="scss" scoped>

.mng-vr-scene2 {
  width: calc(100vw - 0px);
  min-width: 630px;
  height: calc(100vh - 0px);
  background-color: #1d1e1f;
  flex-direction: column;
  justify-content: center;
  position: relative;

  &__stage {
    width: 100%;
    height: calc(100% - 40px);
  }
}
</style>
